"use strict";
function escapeRegexp(queryToEscape) {
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}
exports.escapeRegexp = escapeRegexp;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-select/select/common.js
// module id = ./node_modules/ng2-select/select/common.js
// module chunks = vendor